import script from "./SearchOnlyInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchOnlyInput.vue?vue&type=script&setup=true&lang=ts"

import "./SearchOnlyInput.vue?vue&type=style&index=0&id=63384646&lang=css"

const __exports__ = script;

export default __exports__